var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicHauler = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#BasicHauler_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h10.286v10.286H0z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "BasicHauler_svg__b",
  width: 12,
  height: 11,
  x: -1,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h10.286v10.286H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#BasicHauler_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.51.718a2.685 2.685 0 0 1 2.41 2.67l-.015.274a2.685 2.685 0 0 1-1.94 2.308q.05.049.096.101h1.858V1.376h3.355l2.011 2.683v3.354h-.671a2.012 2.012 0 0 1-4.025 0H3.577l-.01.206a2.012 2.012 0 0 1-4.004 0l-.01-.206a2.013 2.013 0 0 1-4.025 0h-.671V6.071h1.186q.14-.155.307-.279a2.68 2.68 0 0 1-1.48-2.13l-.013-.274A2.685 2.685 0 0 1-2.734.718l.274-.014h4.696zM-2.46 6.74a.672.672 0 1 0 .002 1.343.672.672 0 0 0-.002-1.343m4.026 0a.671.671 0 1 0 0 1.343.671.671 0 0 0 0-1.343m6.036 0a.672.672 0 1 0 .001 1.344.672.672 0 0 0-.001-1.344m-8.567-.67H.068zm-1.495-4.1a1.417 1.417 0 0 0 0 2.833h4.696a1.416 1.416 0 0 0 0-2.833zM6.261 4.06h2.995L7.938 2.382H6.26zM-1.23.703h-1.342V0h1.342z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "BasicHauler_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10.286v10.286H0z"
})))));
export { SvgBasicHauler as ReactComponent };
export default __webpack_public_path__ + "static/media/BasicHauler.90adfde8.svg";